<template>
    <div class="footer" :style="'background:'+backColor+';'">
        <div class="content">
            
            <div class="infoDetail" :style="'border-bottom:'+borderBottom+';'">
                <div class="infoLeft">
                    <dl>
                        <dt><img :src="phone" alt=""></dt>
                        <dd>全国免费服务热线</dd>
                        <dd class="phone">0755-89359799</dd>
                        <dd>工作日：9:00 -18:00</dd>
                    </dl>
                    <dl>
                        <dt><img :src="mail" alt=""></dt>
                        <dd>联系邮箱</dd>
                        <dd class="email">service@lielanghr.com</dd>
                    </dl>
                    <dl>
                        <dt><img :src="adress" alt=""></dt>
                        <dd>公司地址</dd>
                        <dd class="address">广东省深圳市龙岗区平湖大道</dd>
                        <dd class="address">华南城5号交易广场A座811</dd>
                    </dl>
                </div>
                <div class="infoRight">
                    <div>
                        <img :src="appImg" alt="">
                        <span>扫码找工作</span>
                    </div>
                    <div>
                        <img :src="wechat" alt="">
                        <span>扫码关注公众号</span>
                    </div>
                </div>
            </div>
            <!-- <div class="header" :style="'border-bottom:'+borderBottom+';'">
                <img :src="haojobLogo" alt="">
                <ul>
                </ul>
            </div> -->
            <div class="copyright">
                <div class="titCopy">
                    <p>好工作  好工人  好工网   ｜   新蓝领  新平台  新梦想</p>
                    <p>copyright ©2017 好工网：<a href="https://beian.miit.gov.cn" target="
                    _black" style="text-decoration: none;color:#9d9ea9;font-size:12px;font-weight:400;">粤ICP备18148322号-1 </a>版权所有 免责声明</p>
                </div>
                <div style="float:right">
                    <div class="footBan">
                        <a href="https://szcert.ebs.org.cn/3d587ba9-23bf-4ac7-bfa0-c83413d0db9a" target="
                    _black" >
                            <img :src="ban" alt="">
                        </a>
                    </div>
                    <img :src="haojobLogo" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import haojobLogo from '@/assets/footer/logo@2x.png'
import phone from '@/assets/footer/phone@2x.png'
import mail from '@/assets/footer/mail@2x.png'
import ban from '@/assets/ban.gif'
import adress from '@/assets/footer/adress@2x.png'
import appImg from '@/assets/download/miniProgressCode.png'
import wechat from '@/assets/footer/wechat@2x.png'

export default {
    props:['backColor','borderBottom'],
    data(){
        return {
            ban,
            haojobLogo,
            phone,
            mail,
            adress,
            appImg,
            wechat
        }
    }
}

</script>
<style lang="less" scoped>
    .footer{
        background: #1D5EEA;
        width: 100%;
        height: auto;
        .content{
            width:1200px;
            margin: 0 auto;
            .header{
                width: 100%;
                height: 148px;
                border-bottom: 1px solid #6591F1;
                img{
                    width: 144px;
                    height: 67px;
                    display: block;
                    float: left;
                    margin-top: 42px;
                }
                ul{
                    float: right;
                    height: 67px;
                    line-height: 67px;
                    margin-top: 42px;
                    li{
                        font-size:18px;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        float: left;
                        margin-right: 25px;
                        cursor: pointer;
                    }
                }
            }
            .infoDetail{
                width: 100%;
                padding:45px 0;
                overflow: hidden;
                box-sizing: border-box;
                border-bottom: 1px solid #6591F1;
                .infoLeft{
                    float: left;
                    width: auto;
                    dl{
                        margin-right: 70px;
                        float: left;
                        dt{
                            img{
                                width: 48px;
                                height: 48px;
                                display: block;
                            }
                        }
                        dd{
                            font-size:12px;
                            font-weight:400;
                            color:rgba(255,255,255,1);
                            line-height:30px;
                            opacity:0.7;
                        }
                        .phone{
                            font-size:24px;
                            opacity:0.9;
                        }
                        .email{
                            font-size:16px;
                            opacity:0.9;
                        }
                        .address{
                            font-size:14px;
                            line-height:24px;
                            opacity:0.9;
                        }
                    }
                    dl:last-child{
                        margin-right: 0;
                    }
                }
                .infoRight{
                    width: auto;
                    float: right;
                    div{
                        width: 120px;
                        height: auto;
                        float: left;
                        margin-right: 48px;
                        img{
                            width: 120px;
                            height: 120px;
                            display: block;
                        }
                        span{
                            display: block;
                            font-size:12px;
                            font-weight:400;
                            color:rgba(255,255,255,1);
                            line-height:30px;
                            opacity:0.5;
                            text-align: center;
                        }
                    }
                    div:last-child{
                        margin-right: 0;
                    }
                }
            }
            .copyright{
                // padding: 35px 0;
                height: 98px;
                box-sizing: border-box;
                text-align: left;
                .titCopy{
                    float: left;
                    margin-top: 26px;
                    p:first-child{
                        font-size:18px;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        line-height:30px;
                        opacity:0.5;
                    }
                    p:last-child{
                        font-size:12px;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        line-height:30px;
                        opacity:0.5;
                    }
                }
                div{
                    .footBan{
                        float:left;width:105px;height:48px;background:#fff;
                        margin-right: 12px;
                        margin-top: 26px;
                        a{
                            display: block;
                            width: 96px;
                            height: 35px;
                            margin: 0 auto;
                            img{
                                display: block;
                                width: 96px;
                                height: 35px;
                                margin-top: 6.5px;
                            }
                        }
                    }
                    img{
                        float: right;
                        width: 105px;
                        height: 48px;
                        margin-top: 26px;
                    }
                }
            }
        }
    }
</style>